<template>
  <div
    data-component-group="form"
    data-component="edit-banner"
    class="elevation-1"
  >
    <BannerForm
      :banner="banner"
      confirm-trigger-label="Update banner"
      :is-disabled="!canEditDetails"
      :is-loading="isLoading"
      :on-submit="onSubmit"
    >
      <template v-slot:beforeForm>
        <layout-section-header
          title="Details"
          :has-trigger="hasTrigger"
          :trigger-label="triggerLabel"
          @toggle="toggleEditDetails"
        />
      </template>
    </BannerForm>
  </div>
</template>

<script>
  import BannerForm from './AddNew';
  import defaultPagination from '../../../config/pagination';
  import { isObj } from '../../../utils';

  // TODO: Translate component

  export default {
    components: {
      BannerForm,
    },
    props: {
      banner: {
        type: Object,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
      onSubmit: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        canEditDetails: false,
      };
    },
    computed: {
      triggerLabel() {
        return !this.canEditDetails ? 'Edit details' : 'Close';
      },
      hasTrigger() {
        return this.$ability.can('update', 'banner');
      },
    },
    watch: {
      banner(nextBanner) {
        if (isObj(nextBanner)) {
          this.pagination = defaultPagination;
          this.canEditDetails = false;
        }
      },
    },
    methods: {
      toggleEditDetails() {
        this.canEditDetails = !this.canEditDetails;
      },
    },
  };
</script>
